import { TranscriptsPlayer } from "@circle-react-uikit/TranscriptsPlayer";
import { NodeViewWrapper } from "@tiptap/react";

import type { Attachment } from "@/react/types/Attachment";

import { getAttachmentAspectRatio } from "./getAttachmentAspectRatio";

interface VideoRendererProps {
  attachment: Attachment;
}

export const VideoRenderer = ({ attachment }: VideoRendererProps) => (
  <NodeViewWrapper as="div" id="file-wrapper">
    <TranscriptsPlayer
      src={attachment.url}
      type={attachment.content_type}
      mediaTranscoding={attachment.media_transcoding}
      mediaTranscriptId={attachment.media_transcript_id}
      isDownloadable={attachment.is_downloadable}
      poster={attachment.image_variants?.thumbnail}
      downloadUrl={attachment.url}
      chaptersUrl={attachment.chapters_url}
      previewThumbnailsUrl={attachment.preview_thumbnails_url}
      variants={attachment.video_variants}
      signedId={attachment.signed_id}
      aspectRatio={getAttachmentAspectRatio(attachment)}
    />
  </NodeViewWrapper>
);
